import { environment } from '@environments/environment';
import { Observable, throwError, of } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import { map, catchError } from 'rxjs/operators';
import { AuthService } from "./auth/auth.service";

export abstract class BaseService
{
    protected apiBaseUrl: string = "";
    protected apiSegmentUrl: string = "";
    public RETRY_CEILING: number = 0;

    constructor(private currentHttp: HttpClient, private currentRouter: Router, private currentAuthService: AuthService | null) {
        this.apiBaseUrl = environment.apiBaseUrl;
    }

    errorHandler(error: any) {

        var errorMessage;
        if (error.error instanceof ErrorEvent) {
            errorMessage = { errorcode: 0, message: error.error.message };
        } else {
            if (error.headers.get('Token-Expired') === "true") {
                console.log("errorHandler::TOKEN EXPIRED");
            }

            errorMessage = { errorcode: error.status, message: error.message };
        }
        
        return throwError(errorMessage);
    }

    public getBaseUrl(): string {
        let fullURL: string = this.apiBaseUrl;

        if (this.apiSegmentUrl != null) {
            if (this.apiSegmentUrl.charAt(0) != '/') {
                fullURL += "/";
            }
            fullURL += this.apiSegmentUrl;
        }

        return fullURL;
    }

    public tokenCheckAndRefresh(error: any): Observable<boolean> {
      if (error.headers == undefined) {
        return throwError(error);
      }

      // TODO: We need to think about how MSAL works in the world of refreshing
      return of(true);

      //if (error.headers.get('Token-Expired') === "true") {
      //    if (!environment.production)
      //        console.log("tokenCheckAndRefresh::TOKEN EXPIRED");
      //    if (this.currentAuthService?.currentUserValue != undefined) {
      //        return this.currentAuthService.refreshToken(this.currentAuthService?.currentUserValue)
      //            .pipe(
      //                map(n => {
      //                    // successful refresh
      //                    return true;
      //                }),
      //                catchError(this.errorHandler)
      //            );
      //    }
      //    return throwError(error);
      //}
      //return throwError(error);
    }

}
